<template>
  <div id="app" class="dis-f flex-column">
    <toast />
    <!-- <keep-alive include="About,Index">
      <router-view class="flex1" />
    </keep-alive> -->
    <router-view class="flex1" />
    <footerMenu v-if="$route.meta.showMenu" />
  </div>
</template>
<script>
import toast from "@/components/toast.vue";
import footerMenu from "@/components/footerMenu.vue";
export default {
  name: "Home",
  data: () => ({}),
  components: {
    toast,
    footerMenu,
  },
};
</script>
<style lang="scss">
@import "./style/reset";
@import "./style/common";
#app {
  height: 100vh;
}
</style>
